import React, { useEffect, useRef, useState } from "react";
import Loaders from "../Loaders";
import { API_ROUTES } from "../../../utils/constants";
import Nulls from "../Nulls";
import TopNav from "../TopNav";
import Notifications from "../Notifications";
import NavHeader2 from "../NavHeader2";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import CompanyReportTable from "./CompanyReportTable";
import BreadcrumTop from "../BreadcrumTop";
import Spinner from "../../../Spinner/Spinner";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";

export default function ListOfCompany(props) {
  const {
    objectToFormData,
    errorFunction,
    Helmet,
    isLoaded,
    isAuthExpired,
    capitalizeWords,
  } = props;

  useEffect(() => {
    document.title = "List Of Company ";
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  // const [dataTotal, setDataTotal] = useState(0);
  const [dataList, setDataList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isFade, setIsFade] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  const [loginUserRole, setLoginUserRole] = useState("");
  const [companyId, setCompanyId] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    let script;
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
    Promise.all([loadScript("../assets/libs_/js/custom.min.js")])
      .then(() => {
        // Both scripts are loaded
      })
      .catch((error) => {
        console.error("Error loading scripts:", error);
      });
    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const columns1 = [
    {
      name: "Company Name",
      selector: (row) => (row.companyName ? row.companyName : <Nulls />),
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => (row.email ? row.email : <Nulls />),
    },
    {
      name: "User Name",
      selector: (row) => (row.userName ? row.userName : <Nulls />),
    },

  ];

  useEffect(() => {
    setColumns(columns1);
  }, []);

  // Function to handle filter input change
  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  // Filtered data based on filterText
  const filteredData = dataList.filter((company) => {
    return (
      company.userName?.toLowerCase().includes(filterText.toLowerCase()) ||
      company.email?.toLowerCase().includes(filterText.toLowerCase())
    );
  });

  // useEffect(() => {
  //   console.log("data list",dataList);
  // }, [dataList]);

  useEffect(() => {
    // Retrieve userVASData from local storage
    const storedUserData = localStorage.getItem("userVASData");
    // console.log("Stored userVASData:", storedUserData);

    if (storedUserData) {
      try {
        // Parse the JSON string to an object
        const parsedData = JSON.parse(storedUserData);

        // Access companyId and roles
        const id = parsedData.responseDetails?.id;
        const userRoles = parsedData.responseDetails?.roles;

        // console.log("Retrieved companyIdcccc:", companyId);
        // console.log("Retrieved user roles:", userRoles);

        // Use the retrieved data as needed
        if (id) {
          //  console.log("Retrieved id from localStorage:", id);
          setCompanyId(id);
        }

        if (userRoles && userRoles.length > 0) {
          setLoginUserRole(userRoles[0]);
        }
      } catch (error) {
        console.error("Error parsing storedUserData:", error);
      }
    }
  }, []);

  // Fetch user role and id from localStorage on component mount
  useEffect(() => {
    const storedUserData = localStorage.getItem("userVASData");
    if (storedUserData) {
      try {
        const parsedData = JSON.parse(storedUserData);
        const userRoles = parsedData.responseDetails?.roles;

        if (userRoles && userRoles.length > 0) {
          setLoginUserRole(userRoles[0]); // Set the role from stored data
        }
      } catch (error) {
        console.error("Error parsing storedUserData:", error);
      }
    }
  }, []);

  // Redirect the user if not an Admin
  useEffect(() => {
    if (loginUserRole && loginUserRole !== "Admin") {
      // Store a flag that access was denied
      localStorage.setItem("accessDenied", "true");

      // Redirect to the Dashboard
      // need to clarify if both company can see the dashboard infact there should be company
      // dashboard or better still may i should just redirect the user back
      navigate("/company");
    }
    const accessDenied = localStorage.getItem("accessDenied");

    if (accessDenied) {
      Swal.fire({
        title: "Access Denied",
        text: "You don't have access to this page.",
        icon: "info",
        confirmButtonText: "OK",
      }).then(() => {
        // After the alert is dismissed, remove the accessDenied flag
        localStorage.removeItem("accessDenied");
      });
    }
  }, [loginUserRole, navigate]);

  // Don't render the page until we know the role
  if (!loginUserRole) {
    return (
      <div>
        <Spinner loading={loading} />
      </div>
    );
  }

  return (
    <>
      {/* Only render this if the user is an Admin */}
      {loginUserRole == "Admin" ? (
        <div id="main-wrapper" className={isLoaded ? "show" : ""}>
          <TopNav />
          <Notifications />
          <NavHeader2 />
          <Sidebar />
          <div className="content-body mt--10">
            <div className="container-fluid pl-xs-0 pr-xs-0 pt-xs-0">
              <BreadcrumTop title="Companies" />
              <div className="container d-flex justify-content-end align-items-center mb-4">
                {/* Span on the far left */}
                {/* <h5 className="bg-warning text-dark  text-uppercase  px-2 py-2">
                  {companyName
                    ? capitalizeWords(companyName)
                    : "Unknown Company"}
                </h5> */}

                {/* filter */}
                <div className="col-md-5 col-sm-12  mx-1 d-flex justify-content-end">
                  <input
                    type="text"
                    placeholder="Enter Name or Email"
                    value={filterText}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                  <div className="col-md-5 col-sm-12 mx-1">
                    <Link
                      to="/company/create"
                      state={{ companyId: companyId }}
                      className="btn btn-primary"
                    >
                      Create Company
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row mt--10">
                <CompanyReportTable
                  capitalizeWords={capitalizeWords}
                  // dataList={dataList}
                  dataList={filteredData}
                  setDataList={setDataList}
                  isLoading={isLoading}
                  columns={columns}
                  // countPerPage={3}
                  setPage={() => {}}
                  isFade={false}
                  setIsFade={() => {}}
                  isAuthExpired={isAuthExpired}
                  objectToFormData={objectToFormData}
                  setColumns={setColumns}
                />
              </div>
            </div>
          </div>
          <Footer />
        </div>
      ) : (
        <div className="text-primary">You don't have access to this page.</div>
      )}
    </>
  );
}
